import { PDFPageContainer } from "../components/PageContainer";
import { col_2, convertTo2DArray, pdfFontSize } from "./utils";
import React from "react";

export const PDFDashboardCharts = (_, { pdfFormValue, pdfImages }) => {
  const isValidImg = (item) => {
    const img = item?.img;
    if (!img || typeof img !== 'string') return false;
    if (img === 'data:,' || img.startsWith('data:,')) return false;
    if (img.length < 100) return false;
    return true;
  };
  const dashboardCharts = Array.isArray(pdfImages?.dashboardCharts) ? pdfImages.dashboardCharts : [];
  const validCharts = dashboardCharts.filter(isValidImg);
  if (validCharts.length === 0) {
    return null
  }

  const images2d = convertTo2DArray(validCharts)

  return (
    <PDFPageContainer lastPage={true}>
      {
        images2d.map((imgs, index) => {
          return (
            <p-col columnGap={40} key={index}>
              {
                imgs.map((img, idx) => {
                  if (!img) return <p-text></p-text>
                  return (
                    <>
                      <p-stack key={idx} width={col_2} unbreakable={true}>
                        <p-img dw={400} dh={250} width={250} src={img.img}></p-img>
                      </p-stack>
                    </>

                  );
                })
              }
            </p-col>
          )
        })
      }
    </PDFPageContainer>
  );
};

